import { config } from '../config'

export interface UserData {
  id: string,
  email: string,
  telegramId: number,
  stakingKey: string,
  p2pKey: string
}

export interface RequestUserData {
  status: string,
  data: UserData | {},
  error: string | null
}

export interface RequestUpdateAccessToken {
  status: string,
  data: {
    accessToken: string
  },
  error: string | null
}

interface RequestBalance {
  status: string,
  error: string,
  data?: {
    user: number,
    balance: {
      [key: string]: number,
    };
  };
  message: string
}


class UserDataService {
  async fetchData() {
    try {
      const requestOptions: RequestInit = {
        method: "POST",
        credentials: "include"
      };

      const response = await fetch(`${config.bazerAPI}/auth/verify`, requestOptions);
      const resultApi = await response.json();

      console.log(resultApi)

      return resultApi as RequestUserData
    } catch (error) {
      console.error(`error fetching user data: ${error.message}`);

      return {
        status: 'error',
        data: {},
        error: `error fetching user data: ${error.message}`
      }
    }
  }

  async updateAccessToken(): Promise<RequestUpdateAccessToken> {
    try {
      const requestOptions: RequestInit = {
        method: "POST",
        credentials: "include"
      };

      const response = await fetch(`${config.bazerAPI}/auth/refresh`, requestOptions);
      const resultApi = await response.json();

      return resultApi as RequestUpdateAccessToken
    } catch (error) {
      console.error(`error update access token: ${error.message}`);

      return {
        status: 'error',
        data: {
          accessToken: ''
        },
        error: `error update access token: ${error.message}`
      }
    }
  }

  async getUserBalance(id: number): Promise<RequestBalance> {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions: RequestInit = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ "userId": id }),
        redirect: "follow" as RequestRedirect
      };

      const restponse = await fetch(`${config.p2pAPI}/api/user/get-user-balance`, requestOptions);
      const resultApi = await restponse.json();

      return resultApi as RequestBalance
    } catch (error) {
      console.error(`error geting user balance: ${error.message}`);

      return {
        status: 'error',
        error: 'error geting user balance',
        message: error.message
      }
    }
  }
}

export default new UserDataService;